if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

function wait_for_elem(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

// Close cart drawer function
function closeCartDrawer() {
  document.querySelector("#cartDrawer")?.classList.remove("opened");
  document.querySelector("#cartDrawerBackdrop")?.classList.remove("active");
}

// Open cart drawer function
function openCartDrawer() {
  document.querySelector("#cartDrawer")?.classList.add("opened");
  document.querySelector("#cartDrawerBackdrop")?.classList.add("active");
}

wait_for_elem(".jsDrawerClose").then((elem) => {
  elem.addEventListener("click", closeCartDrawer);
});

// Close cart when clicking backdrop
wait_for_elem("#cartDrawerBackdrop").then((elem) => {
  elem.addEventListener("click", closeCartDrawer);
});

const drawer_sample_names = ".drawerSamplesBox .drawerSamplesName label";

function toTitleCase(str) {
  return str
    .toLowerCase()
    .replace(/(?:^|\s)\w/g, function (match) {
      return match.toUpperCase();
    });
}

window.fixCartSampleNames = () => {
  wait_for_elem(drawer_sample_names).then((drawer_sample_name) => {
    let drawerSampleNames = document.querySelectorAll(drawer_sample_names);
  
    drawerSampleNames.forEach(function (title) {
      let originalTitle = title.getAttribute('data-title');
      let titleCaseTitle = toTitleCase(originalTitle).replace("By Far", "BY FAR");
  
      title.textContent = titleCaseTitle;
    });     
  });  
};

window.fixCartSampleNames();


function replaceCurrencySymbolCart(elem) {
  // Recursive function to walk through all text nodes
  function walk(node) {
    for (let i = 0; i < node.childNodes.length; i++) {
      const child = node.childNodes[i];
      if (child.nodeType === 3) {
        child.nodeValue = child.nodeValue.replace(/лв/g, "BGN");
      } else {
        walk(child);
      }
    }
  }

  walk(elem);
}

function setBGNInCart() {
  wait_for_elem("#cartDrawer").then((cartElem) => {
    replaceCurrencySymbolCart(cartElem);

    let currency_interval_counter = 0;

    const intervalEverySecond = setInterval(() => {
      replaceCurrencySymbolCart(cartElem);

      currency_interval_counter++;

      if (currency_interval_counter >= 10) {
        clearInterval(intervalEverySecond);
      }
    }, 1000);
  });
}

async function getCorrectPrice(productId, variantId) {
  let countryCode = window.Shopify.country || "DE"; // get country from cart or default to 'US'
  let response = await fetch("/api/2023-04/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "312c68c75076c4c6c48eb4eb2e159bae",
    },
    body: JSON.stringify({
      query: `query getProductById($id: ID!) @inContext(country: ${countryCode}) {
                            product(id: $id) {
                                variants(first: 100) {
                                    nodes{
                                        price {
                                          amount
                                          currencyCode
                                        }
                                        compareAtPrice {
                                          amount
                                          currencyCode
                                        }
                                        id
                                        title
                                    }
                                }
                            }
                        }`,
      variables: {
        id: `gid://shopify/Product/${productId}`,
      },
    }),
  });
  let json = await response.json();
  /*
  console.log("query")
  console.log(`query getProductById($id: ID!) @inContext(country: ${countryCode}) {
                            product(id: $id) {
                                variants(first: 100) {
                                    nodes{
                                        price {
                                          amount
                                          currencyCode
                                        }
                                        compareAtPrice {
                                          amount
                                          currencyCode
                                        }
                                        id
                                        title
                                    }
                                }
                            }
                        }`)
  console.log("variables")
  console.log({
        id: `gid://shopify/Product/${productId}`,
      })
  console.log("json received")
  console.log({productId, variantId})
  console.log(json)
  */
  let variants = json.data.product.variants.nodes;
  let variant = variants.find(
    (variant) => variant.id === `gid://shopify/ProductVariant/${variantId}`
  );
  if (!variant) {
    return undefined;
  }
  let result = {
    price: variant.price.amount,
    priceCurrencyCode: variant.price.currencyCode,
  };
  if (variant.compareAtPrice) {
    result.compareAtPrice = variant.compareAtPrice.amount;
    result.compareAtPriceCurrencyCode = variant.compareAtPrice.currencyCode;
  }
  return result;
}

// --- Dynamic "Complete the look" upsell (US): Storefront API, market-aware ---
// Renders the cart upsell from live data in the buyer's market context, so only
// products offered AND in stock for the US catalog are shown. Picks N per
// collection (see data-upsell-spec) at random once per page load, then reuses
// the same set so the grid is stable across cart updates.
var upsellProductsCache = null;
var upsellProductsFetching = false;

function parseUpsellSpec(spec) {
  // "belts:2,mini-mini:2,stockings:2" -> [{handle:'belts',count:2}, ...] (display order)
  return (spec || "")
    .split(",")
    .map(function (part) {
      var bits = part.split(":");
      var handle = (bits[0] || "").trim();
      var count = parseInt(bits[1], 10);
      return { handle: handle, count: isNaN(count) ? 0 : count };
    })
    .filter(function (s) {
      return s.handle && s.count > 0;
    });
}

function shuffleInPlace(arr) {
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }
  return arr;
}

function gidToId(gid) {
  return (gid || "").toString().split("/").pop();
}

function normalizeUpsellNode(node) {
  var price = node.priceRange && node.priceRange.minVariantPrice;
  return {
    id: gidToId(node.id),
    handle: node.handle,
    title: node.title,
    image: node.featuredImage ? node.featuredImage.url : "",
    priceAmount: price ? price.amount : null,
    priceCurrency: price ? price.currencyCode : null,
    variants: (node.variants ? node.variants.nodes : []).map(function (v) {
      return { id: gidToId(v.id), title: v.title, available: v.availableForSale };
    }),
  };
}

async function fetchDynamicUpsellProducts(spec, inCartIds) {
  inCartIds = inCartIds || {};
  var countryCode = (window.Shopify && window.Shopify.country) || "US";
  var parts = spec
    .map(function (s, i) {
      return (
        "c" + i + ": collection(handle: " + JSON.stringify(s.handle) + ") {" +
        " products(first: 50) { nodes {" +
        " id title handle availableForSale" +
        " featuredImage { url(transform: { maxWidth: 200, maxHeight: 200 }) }" +
        " priceRange { minVariantPrice { amount currencyCode } }" +
        " variants(first: 50) { nodes { id title availableForSale } }" +
        " } } }"
      );
    })
    .join("\n");
  var query = "query @inContext(country: " + countryCode + ") {\n" + parts + "\n}";

  var response = await fetch("/api/2023-04/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "312c68c75076c4c6c48eb4eb2e159bae",
    },
    body: JSON.stringify({ query: query }),
  });
  var json = await response.json();
  var data = (json && json.data) || {};

  var picked = [];
  spec.forEach(function (s, i) {
    var col = data["c" + i];
    if (!col || !col.products) return;
    var available = col.products.nodes.filter(function (n) {
      return n.availableForSale && !inCartIds[gidToId(n.id)];
    });
    shuffleInPlace(available);
    available.slice(0, s.count).forEach(function (n) {
      picked.push(normalizeUpsellNode(n));
    });
  });
  return picked;
}

function formatUpsellPrice(amount, currency) {
  if (amount == null) return "";
  var num = parseFloat(amount);
  var str;
  try {
    str = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency || "USD",
    }).format(num);
  } catch (e) {
    str = num + " " + (currency || "");
  }
  // Drop trailing .00 / ,00 for cleaner display
  return str.replace(/[.,]00(\D*)$/, "$1");
}

function escapeUpsellHtml(str) {
  return (str == null ? "" : String(str))
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// Build a lookup of the product ids currently in the cart, so the upsell can
// skip anything the customer has already added.
function cartProductIdSet(cart) {
  var set = {};
  ((cart && cart.items) || []).forEach(function (it) {
    set[String(it.product_id)] = true;
  });
  return set;
}

// Drop upsell products already in the cart — no point upselling something the
// customer has already added (this is what removed the stray "in cart" tick).
function filterUpsellNotInCart(products, cart) {
  if (!products || !products.length) return products || [];
  var inCart = cartProductIdSet(cart);
  return products.filter(function (p) {
    return !inCart[String(p.id)];
  });
}

// Sort upsell variants into a sensible size order (XS, S, M, L, XL...) so the
// size list isn't shown in the API's arbitrary order. Numeric sizes (35, 36...)
// sort numerically; anything unrecognised falls back to alphabetical/last.
function sortVariantsBySize(variants) {
  var order = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "OS", "ONE SIZE", "ONESIZE"];
  return variants.slice().sort(function (a, b) {
    var ta = (a.title || "").trim().toUpperCase();
    var tb = (b.title || "").trim().toUpperCase();
    var na = parseFloat(ta);
    var nb = parseFloat(tb);
    var aNum = /^\d/.test(ta) && !isNaN(na);
    var bNum = /^\d/.test(tb) && !isNaN(nb);
    if (aNum && bNum) return na - nb;
    var ia = order.indexOf(ta);
    var ib = order.indexOf(tb);
    if (ia === -1 && ib === -1) return ta.localeCompare(tb);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });
}

// Turn a samples grid into an Owl carousel — but ONLY once it actually holds
// product boxes. The US "Complete the look" grid is filled asynchronously from
// the Storefront API, so if Owl runs on the still-empty grid it wraps nothing
// and the late paint gets blocked. Calling this after every paint (and skipping
// empty / already-initialised grids) keeps both the US and server-rendered
// (non-US) grids working.
function initSamplesCarousel($grid) {
  if (!$grid || !$grid.length) return;
  if (!$grid.find(".drawerSamplesBox").length) return; // nothing painted yet
  if ($grid.hasClass("owl-loaded")) return; // already a carousel this render
  $grid.owlCarousel({
    items: 3,
    autoHeight: true,
    nav: true,
    dots: false,
    touchDrag: true,
  });
}

function paintDynamicUpsell($grid, products) {
  var html = products
    .map(function (p) {
      var img = p.image
        ? '<img class="img-responsive" src="' + escapeUpsellHtml(p.image) + '" alt="' + escapeUpsellHtml(p.title) + '" />'
        : "";
      return (
        '<div class="drawerSamplesBox" data-handle="' + escapeUpsellHtml(p.handle) +
        '" data-product-id="' + escapeUpsellHtml(p.id) +
        '" data-variants="' + escapeUpsellHtml(JSON.stringify(p.variants)) + '">' +
        '<div class="drawerSamplesImage">' + img + "</div>" +
        '<div class="drawerSamplesName">' +
        '<label data-title="' + escapeUpsellHtml(p.title) + '">' + escapeUpsellHtml(p.title) + "</label>" +
        '<span class="drawerSamplesPrice">' + escapeUpsellHtml(formatUpsellPrice(p.priceAmount, p.priceCurrency)) + "</span>" +
        "</div></div>"
      );
    })
    .join("");
  $grid.html(html);
  // Boxes are in the DOM now — safe to build the carousel (Owl ran too early
  // on the empty grid via ajaxCart.afterCartLoad and skipped this one).
  initSamplesCarousel($grid);
}

ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};
ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};
ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  }
};
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    beforeSend: function () {
      $("body").addClass("velaCartAdding");
    },
    success: function (line_item) {
      $("body").removeClass("velaCartAdding");
      if (window.ajaxcart_type == "modal") {
        if (line_item.image != null) {
          $(".headerCartModal")
            .find(".cartProductImage img")
            .attr("src", line_item.image);
        } else {
          $(".headerCartModal")
            .find(".cartProductImage img")
            .attr("src", "//placehold.it/100x100");
        }
        $(".headerCartModal").find(".productTitle").html(line_item.title);
        $(".headerCartModal").addClass("active");
      }
      if (typeof callback === "function") {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.addItemFromCart = function (formData, callback, errorCallback) {
  var form = null;
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (typeof callback === "function") {
        callback(response, form);
      } else {
        ShopifyAPI.onItemAdded(response, form);
      }
    })
    .catch((error) => {
      if (typeof errorCallback === "function") {
        errorCallback(error);
      } else {
        alert(error);
      }
    });
};

ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $drawerCartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer;
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemAddedCallbackCart,
    itemErrorCallback,
    itemErrorCallbackCart,
    cartUpdateCallback,
    buildCart,
    updateSamples,
    renderDynamicUpsell,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    createQtySelectors,
    qtySelectors,
    validateQty;
  init = function (options) {
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#cartContainer",
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      drawerCartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: window.money,
      disableAjaxCart: false,
      enableQtySelectors: true,
    };
    $.extend(settings, options);
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $drawerCartCountSelector = $(settings.drawerCartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $body = $("body");
    isUpdating = false;
    if (settings.enableQtySelectors) {
      qtySelectors();
    }
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }
    adjustCart();
  };
  loadCart = function () {
    $body.addClass("ajaxcartIsLoading");
    ShopifyAPI.getCart(cartUpdateCallback);
    setTimeout(() => openCartDrawer(), 250);
  };
  updateCountPrice = function (cart) {
    document
      .querySelectorAll(settings.cartCountSelector)
      .forEach(function (element) {
        element.innerHTML = cart.item_count;
        element.classList.remove("hidden-count");
        if (cart.item_count === 0) {
          element.classList.add("hidden-count");
          document
            .querySelector("span.byfar-icon-bag")
            .classList.remove("full");
          document.querySelector("span.byfar-icon-bag").classList.add("empty");
        } else {
          document
            .querySelector("span.byfar-icon-bag")
            .classList.remove("empty");
          document.querySelector("span.byfar-icon-bag").classList.add("full");
        }
      });

    document
      .querySelectorAll(settings.drawerCartCountSelector)
      .forEach(function (element) {
        element.innerText = cart.item_count;
      });

    if (cart.total_price) {
      document
        .querySelectorAll(settings.cartCostSelector)
        .forEach(function (element) {
          element.innerText = theme.Currency.formatMoney(
            cart.total_price,
            settings.moneyFormat
          );
        });
    }
    // if($drawerCartCountSelector) {
    //     $drawerCartCountSelector.text(cart.item_count);
    // }
    // if ($cartCostSelector) {
    //     $cartCostSelector.text(theme.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    // }
  };
  formOverride = function () {
    if (window.ajaxcart_type != "page") {
      $formContainer.on("submit", function (evt) {
        evt.preventDefault();
        $addToCart.removeClass("is-added").addClass("is-adding");
        $(".qtyError").remove();
        ShopifyAPI.addItemFromForm(
          evt.target,
          itemAddedCallback,
          itemErrorCallback
        );
        if ($formContainer.hasClass("formQuickview")) {
          $("#velaQuickView").fadeOut(500);
          $(".jsQuickview").html("");
          $(".jsQuickview").fadeOut(500);
        }
      });
    }
  };
  itemAddedCallback = function (product) {
    $addToCart.removeClass("is-adding").addClass("is-added");
    ShopifyAPI.getCart(cartUpdateCallback);
  };
  itemAddedCallbackCart = function (product) {
    $addToCart.removeClass("is-adding").addClass("is-added");
    ShopifyAPI.getCart(cartUpdateCallback);
  };
  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");
    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after(
          '<div class="alert alert-danger qtyError">' +
            data.description +
            "</div>"
        );
      }
    }
  };
  itemErrorCallbackCart = function (error) {
    $addToCart.removeClass("is-adding is-added");
    if (!!error.statusText) {
      if (error.status == 422) {
        $formContainer.after(
          '<div class="alert alert-danger qtyError">' +
            error.statusText +
            "</div>"
        );
      }
    }
  };
  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };
  updateSamples = function (cart) {
    // Reset visual state
    $(".drawerStockings .drawerSamplesBox").removeClass("in-cart");

    // Mark boxes whose products are already in cart
    $(".drawerStockings .drawerSamplesBox").each(function () {
      var $item = $(this);
      var productId = $item.data("product-id");
      $.each(cart.items, function (i, cartItem) {
        if (cartItem.product_id == productId) {
          $item.addClass("in-cart");
        }
      });
    });
  };
  // Fill the US "Complete the look" grid from the Storefront API (market-aware).
  // The grid is re-injected empty on every cart render, so repopulate each time:
  // fetch + pick once, then paint from cache on subsequent renders.
  renderDynamicUpsell = function (cart) {
    var $cont = $(".drawerStockings[data-upsell-dynamic='true']");
    if (!$cont.length) return; // non-US (server-rendered) or no upsell
    var $grid = $cont.find(".drawerSamplesGrid");
    if ($grid.find(".drawerSamplesBox").length) return; // already painted this render

    if (upsellProductsCache) {
      var visible = filterUpsellNotInCart(upsellProductsCache, cart);
      if (visible.length) {
        paintDynamicUpsell($grid, visible);
        updateSamples(cart);
      } else {
        $cont.hide(); // everything's already in the cart — nothing to upsell
      }
      return;
    }
    if (upsellProductsFetching) return;
    upsellProductsFetching = true;

    var spec = parseUpsellSpec($cont.attr("data-upsell-spec"));
    fetchDynamicUpsellProducts(spec, cartProductIdSet(cart))
      .then(function (products) {
        upsellProductsCache = products || [];
      })
      .catch(function (err) {
        upsellProductsCache = [];
        console.error("Complete the look: upsell fetch failed", err);
      })
      .then(function () {
        upsellProductsFetching = false;
        var $c = $(".drawerStockings[data-upsell-dynamic='true']");
        var $g = $c.find(".drawerSamplesGrid");
        var visibleAfterFetch = filterUpsellNotInCart(upsellProductsCache, cart);
        if ($c.length && !$g.find(".drawerSamplesBox").length) {
          if (visibleAfterFetch.length) {
            paintDynamicUpsell($g, visibleAfterFetch);
            updateSamples(cart);
          } else {
            $c.hide();
          }
        }
      });
  };
  buildCart = async function (cart) {
    $cartContainer.empty();
    if (window.ajaxcart_type == "modal") {
      if (cart.item_count === 0) {
        $cartContainer.append(
          '<div class="headerCartEmpty">' + window.cart_empty + "</div>"
        );
        cartCallback(cart);
        return;
      }
      var items = [],
        item = {},
        data = {};
      var source = $("#headerCartTemplate").html();
      // create function for comparing if two arguments are equal
      Handlebars.registerHelper("ifEquals", function (arg1, arg2) {
        return arg1 == arg2 ? true : false;
      });
      Handlebars.registerHelper("ifNotEquals", function (arg1, arg2, options) {
        if (arg1 != arg2) {
          return options.fn(this);
        }
        return options.inverse(this);
      });

      var template = Handlebars.compile(source);
      $.each(cart.items, function (index, cartItem) {
        if (cartItem.image != null) {
          var prodImg = cartItem.image
            .replace(/(\.[^.]*)$/, "_200x$1")
            .replace("http:", "");
        } else {
          var prodImg =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
        item = {
          id: cartItem.variant_id,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: theme.Currency.formatMoney(
            cartItem.price,
            settings.moneyFormat
          ),
          vendor: cartItem.vendor,
        };
        items.push(item);
      });
      data = {
        items: items,
        note: cart.note,
        totalPrice: theme.Currency.formatMoney(
          cart.total_price,
          settings.moneyFormat
        ),
      };
      $cartContainer.append(template(data));
      cartCallback(cart);
    } else {
      if (cart.item_count === 0) {
        $cartContainer.append(
          '<div class="drawerCartEmpty">' + window.cart_empty + "</div>"
        );
        cartCallback(cart);
        return;
      }
      var items = [],
        item = {},
        data = {};
      var source = $("#CartTemplate").html();
      // create function for comparing if two arguments are equal
      Handlebars.registerHelper("ifEquals", function (arg1, arg2) {
        return arg1 == arg2 ? true : false;
      });
      Handlebars.registerHelper("ifNotEquals", function (arg1, arg2, options) {
        if (arg1 != arg2) {
          return options.fn(this);
        }
        return options.inverse(this);
      });
      Handlebars.registerHelper("isPublicProperty", function (key, options) {
        // Hide properties starting with underscore
        if (typeof key === 'string' && key.indexOf('_') === 0) {
          return options.inverse(this);
        }
        return options.fn(this);
      });
      // var template = Handlebars.compile(source);
      // let item_promises = [];
      // console.log(cart);
      // $.each(cart.items, function(index, cartItem) {
      //     item_promises.push(getCorrectPrice(cartItem.product_id, cartItem.variant_id).then((data) => {
      //         console.log(data);
      //         if (cartItem.image != null){
      //             var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      //         } else {
      //             var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      //         }
      //         var price = data ? data.price.replace(".0","") + ' ' + data.currencyCode
      //                   : theme.Currency.formatMoney(cartItem.price, settings.moneyFormat);
      //         item = {
      //             id: cartItem.variant_id,
      //             line: index + 1, // Shopify uses a 1+ index in the API
      //             url: cartItem.url,
      //             img: prodImg,
      //             name: cartItem.product_title,
      //             variation: cartItem.variant_title,
      //             properties: cartItem.properties,
      //             itemAdd: cartItem.quantity + 1,
      //             itemMinus: cartItem.quantity - 1,
      //             itemQty: cartItem.quantity,
      //             price: price,
      //             vendor: cartItem.vendor
      //         };
      //         items.push(item);
      //     }));
      // });

      // await Promise.all(item_promises);

      // const formattedPrice = new Intl.NumberFormat('en', { style: 'currency', currency: cart.currency }).format(cart.total_price);
      // console.log(`${cart.total_price} ${formattedPrice}`)

      // data = {
      //     items: items,
      //     note: cart.note,
      //     totalPrice: `${cart.total_price / 100} ${cart.currency}`
      // }
      // $cartContainer.append(template(data));
      // cartCallback(cart);
      let item_promises = [];
      var template = Handlebars.compile(source);
      $.each(cart.items, function (index, cartItem) {
        item_promises.push(
          getCorrectPrice(cartItem.product_id, cartItem.variant_id).then(
            (data) => {
              if (cartItem.image != null) {
                var prodImg = cartItem.image
                  .replace(/(\.[^.]*)$/, "_200x$1")
                  .replace("http:", "");
              } else {
                var prodImg =
                  "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
              }
              item = {
                id: cartItem.variant_id,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: theme.Currency.formatMoney(
                  data.price * 100,
                  settings.moneyFormat
                ),
                vendor: cartItem.vendor,
              };
              let cart_item_extra_discount = false;
              let cart_item_extra_discount_amount = 0;
              try {
                const discountTitle = cartItem.discounts[0].title;
                if (discountTitle === "EXTRA25") {
                  cart_item_extra_discount = true;
                  cart_item_extra_discount_amount = 25;
                } else if (discountTitle === "EXTRA10") {
                  cart_item_extra_discount = true;
                  cart_item_extra_discount_amount = 10;
                }
              } catch (e) {}
              if (cart_item_extra_discount) {
                item["extra25"] = true;
                item["extra_discount_amount"] = cart_item_extra_discount_amount;
              }
              if ("compareAtPrice" in data) {
                item["compareAtPrice"] = theme.Currency.formatMoney(
                  data.compareAtPrice * 100,
                  settings.moneyFormat
                );
              } else {
                if (cartItem.line_price < cartItem.original_line_price) {
                  item["compareAtPrice"] = theme.Currency.formatMoney(
                    cartItem.original_line_price,
                    settings.moneyFormat
                  );
                  item["price"] = theme.Currency.formatMoney(
                    cartItem.line_price,
                    settings.moneyFormat
                  );
                } else {
                  item["compareAtPrice"] = "";
                }
              }
              items.push(item);
            }
          )
        );
      });

      await Promise.all(item_promises);

      data = {
        items: items,
        note: cart.note,
        totalPrice: theme.Currency.formatMoney(
          cart.total_price,
          settings.moneyFormat
        ),
      };

      $cartContainer.append(template(data));
      cartCallback(cart);
      if (window.fixCartSampleNames) {
        window.fixCartSampleNames();
      }
    }
  };
  cartCallback = function (cart) {
    setBGNInCart();
    updateSamples(cart);
    renderDynamicUpsell(cart);
    $body.removeClass("drawerIsLoading");
    $body.trigger("ajaxCart.afterCartLoad", cart);
  };
  adjustCart = function () {
    $body.on("click", ".qtyAdjust", function () {
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".qtyNum"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));
      var qty = validateQty(qty);
      if ($el.hasClass("velaQtyPlus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    $body.on("change", ".qtyNum", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));
      var qty = validateQty(qty);
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("change", ".drawerQtySelect", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = this.value;
      var qty = validateQty(qty);
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });
    $body.on("focus", ".qtyAdjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });
    $body.on("click", ".cartRemove", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = 0;
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("click", ".exclusiveServicesHeader", function () {
      $(".exclusiveServices").toggleClass("active");
    });

    // Close variant picker when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".drawerStockings").length) {
        $(".drawerStockings").removeClass("has-selection picker-open");
        $(".drawerSamplesBox").removeClass("selected");
        $(".drawerSamples > .drawerSamplesVariantPicker").hide();
        $(".drawerSamplesVariantOptions").hide();
      }
    });

    // Toggle variant picker dropdown
    $body.on("click", ".drawerSamples > .drawerSamplesVariantPicker .drawerSamplesVariantSelect", function (e) {
      e.stopPropagation();
      var $stockings = $(this).closest(".drawerStockings");
      var $options = $(this).siblings(".drawerSamplesVariantOptions");
      var isOpen = $options.is(":visible");

      if (isOpen) {
        $options.hide();
        $stockings.removeClass("picker-open");
      } else {
        $options.show();
        $stockings.addClass("picker-open");
      }
    });

    // Handle variant option selection (add to cart)
    $body.on("click", ".drawerSamples > .drawerSamplesVariantPicker .drawerSamplesVariantOption", function (e) {
      e.stopPropagation();
      var $option = $(this);
      var $stockings = $option.closest(".drawerStockings");
      var $picker = $option.closest(".drawerSamplesVariantPicker");
      var variantId = $option.data("variant-id");

      $picker.find(".drawerSamplesVariantOptions").hide();
      $stockings.removeClass("picker-open");

      var formData = {
        items: [{ id: variantId, quantity: 1 }]
      };
      ShopifyAPI.addItemFromCart(formData, itemAddedCallbackCart, itemErrorCallbackCart);

      $stockings.removeClass("has-selection");
      $(".drawerSamplesBox").removeClass("selected");
      $picker.hide();
    });

    // Main click handler for tights upsell box
    $body.on("click", ".drawerStockings .drawerSamplesBox", function (e) {
      var $box = $(this);
      var $stockings = $box.closest(".drawerStockings");
      var $picker = $stockings.find("> .drawerSamplesVariantPicker");
      var handle = $box.data("handle");

      // If clicking same selected box, deselect
      if ($box.hasClass("selected")) {
        $box.removeClass("selected");
        $stockings.removeClass("has-selection picker-open");
        $picker.hide();
        $picker.find(".drawerSamplesVariantOptions").hide();
        return;
      }

      // Select this box
      $(".drawerSamplesBox").removeClass("selected");
      $box.addClass("selected loading");
      $stockings.addClass("has-selection");

      // Render the size options / add to cart from a list of available variants.
      var applyVariants = function (availableVariants) {
        $box.removeClass("loading");

        if (availableVariants.length > 1) {
          availableVariants = sortVariantsBySize(availableVariants);
          var $optionsList = $picker.find(".drawerSamplesVariantOptions");
          $optionsList.empty();
          availableVariants.forEach(function (variant) {
            $optionsList.append(
              '<li class="drawerSamplesVariantOption" data-variant-id="' + variant.id + '">' +
              variant.title +
              '</li>'
            );
          });
          $picker.find(".drawerSamplesVariantSelected").text("Select size");
          $picker.show();
          // Auto-expand the size list so the size choices are visible right away
          // (no extra click on "Select size" needed).
          $picker.find(".drawerSamplesVariantOptions").show();
          $stockings.addClass("picker-open");
          // Scroll the drawer so the expanded size list clears the absolutely
          // positioned footer (the picker is the last content in the scroll
          // area, so scrolling to the bottom reveals it fully). Defer to the
          // next frame so the just-shown options are in the scroll height, and
          // re-assert once because a smooth scroll can be pre-empted by the
          // drawer/carousel still settling its height.
          // Use an instant scroll: smooth scrolling is suppressed on this
          // container, so behavior:"smooth" silently does nothing.
          var scroller = $picker.closest(".ajaxCartInner").get(0);
          if (scroller) {
            var scrollToBottom = function () {
              scroller.scrollTop = scroller.scrollHeight;
            };
            window.requestAnimationFrame(scrollToBottom);
            setTimeout(scrollToBottom, 120);
          }
        } else if (availableVariants.length === 1) {
          var formData = {
            items: [{ id: availableVariants[0].id, quantity: 1 }]
          };
          ShopifyAPI.addItemFromCart(formData, itemAddedCallbackCart, itemErrorCallbackCart);
          $stockings.removeClass("has-selection");
          $box.removeClass("selected");
          $picker.hide();
        } else {
          // Nothing buyable for this market — reset state
          $stockings.removeClass("has-selection");
          $box.removeClass("selected");
        }
      };

      // Dynamic US upsell boxes carry market-accurate variants in data-variants;
      // use those so sizes respect US availability. Server-rendered boxes don't,
      // so fall back to the product JSON.
      var presetVariants = $box.attr("data-variants");
      if (presetVariants) {
        var parsedVariants;
        try { parsedVariants = JSON.parse(presetVariants); } catch (e) { parsedVariants = []; }
        applyVariants(parsedVariants.filter(function (v) { return v.available; }));
        return;
      }

      // Fetch product data to get variants
      fetch('/products/' + handle + '.js')
        .then(function (response) { return response.json(); })
        .then(function (product) {
          applyVariants(product.variants.filter(function (v) { return v.available; }));
        })
        .catch(function (err) {
          $box.removeClass("loading selected");
          $stockings.removeClass("has-selection");
          console.error('Error fetching product:', err);
        });
    });

    const drawerProductTitlesSelector = ".drawerProductTitle a";
    $body.on("ajaxCart.afterCartLoad", function () {
      wait_for_elem(drawerProductTitlesSelector).then((drawer_sample_name) => {
        let drawerProductTitles = document.querySelectorAll(drawerProductTitlesSelector);
      
        drawerProductTitles.forEach(function (title) {
          let originalTitle = title.getAttribute('data-title');
          let titleCaseTitle = toTitleCase(originalTitle).replace("By Far", "BY FAR");
      
          title.textContent = titleCaseTitle;
        });     
      });
    });
    $body.on("ajaxCart.afterCartLoad", function () {
      // Init Owl only on grids that are already populated (the non-US,
      // server-rendered grid). The US grid is empty here because its products
      // are still being fetched — paintDynamicUpsell() builds its carousel once
      // the boxes land. initSamplesCarousel() skips empty / already-built grids.
      $(".drawerSamplesGrid").each(function () {
        initSamplesCarousel($(this));
      });
    });
    function updateQuantity(line, qty) {
      isUpdating = true;
      var $row = $('.ajaxCartRow[data-line="' + line + '"]').addClass(
        "is-loading"
      );
      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };
  adjustCartCallback = function (cart) {
    isUpdating = false;
    updateCountPrice(cart);
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 150);
  };
  createQtySelectors = function () {
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();
        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;
        var source = $("#velaAjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
          };
        $el.after(template(data)).remove();
      });
    }
  };
  qtySelectors = function () {
    var numInputs = $('input[type="number"]');
    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id");
        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;
        var source = $("#velaJsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };
        $el.after(template(data)).remove();
      });
      $("body").on("click", ".velaQtyAdjust", function () {
        var $el = $(this),
          id = $el.data("id"),
          $qtySelector = $el.siblings(".velaQtyNum"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));
        var qty = validateQty(qty);
        if ($el.hasClass("velaQtyPlus")) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
        $qtySelector.val(qty);
      });
    }
  };
  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    } else {
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart,
  };
  return module;
})(ajaxCart || {}, jQuery);
$(document).ready(function () {
  ajaxCart.init({
    formSelector: ".formAddToCart",
    cartContainer: "#cartContainer",
    addToCartSelector: ".btnAddToCart",
    cartCountSelector: "#CartCount",
    drawerCartCountSelector: "#drawerCartCount",
    cartCostSelector: "#CartCost",
    moneyFormat: window.money,
  });
});

window.___ajaxCart = ajaxCart;
